export const btnBgColor = {
  type: String,
  default: "bg-secondary",
  description: "Background button color",
};
